<template>
    <va-edit-layout>
        <auction-category-form
            :id="id"
            :item="item"
            :title="title"
        ></auction-category-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"]
};
</script>
